import classNames from 'classnames';
import { FlexContainer, AnimatedHide } from 'components';
import { observer } from 'mobx-react-lite';
import { useUIState } from 'state';
import ToggleSideBarButton from '../ToggleSideBarButton';
import styles from './SideBar.module.scss';

/**
 * SideBar
 *
 * @return {JSX.Element}
 */
const SideBar = ({ className, children }) => {
  const uiState = useUIState();

  return (
    <AnimatedHide
      className={classNames(
        styles.SideBar,
        className,
        `${SideBar.displayName}`
      )}
      classNameWidth={styles.SideBarWidth}
      isClosed={uiState.isSideBarClosed}
      column
    >
      <FlexContainer className={styles.Header}>
        <ToggleSideBarButton className={styles.ToggleButton} backdrop />
      </FlexContainer>
      <FlexContainer className={styles.Body} flex column overflow>
        {children}
      </FlexContainer>
    </AnimatedHide>
  );
};

SideBar.displayName = 'SideBar';

export default observer(SideBar);
